import './Tooltip-59734b6f.css';

var classes = {"Tooltip":"prc-TooltipV2-Tooltip-cYMVY","tooltip-appear":"prc-TooltipV2-tooltip-appear-hLf77","KeybindingHintContainer":"prc-TooltipV2-KeybindingHintContainer-iabqv","HasTextBefore":"prc-TooltipV2-HasTextBefore-cCzYC"};

export { classes as default };
